import { Table } from "@chakra-ui/react"
import { DateTime } from "luxon"

export default function TouchRow({ touch, onClick }) {
  return(
    <Table.Row onClick={onClick}>
      <Table.Cell className="w-1/4 overflow-hidden text-ellipsis whitespace-nowrap max-w-xs">
        {touch.attributes.type}
      </Table.Cell>
      <Table.Cell className="w-1/4 overflow-hidden text-ellipsis whitespace-nowrap max-w-xs">
        {DateTime.fromISO(touch.attributes['touch-on']).toLocaleString()}
      </Table.Cell>
      <Table.Cell className="w-1/4 overflow-hidden text-ellipsis whitespace-nowrap max-w-xs">
        {touch.attributes['created-by']}
      </Table.Cell>
    </Table.Row>
  )
}